module.exports = __webpack_public_path__ + "static/media/logo.9e0afd97.jpg";